import React from "react";
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";

import {getCurrentUpdateCount, savePricingPageChanges} from "../pricingSavingLogic";


const PricingTopPanelButtons = (props) => {

  const {savePricingPageChanges, pricingUpdatesCount} = props;

  const saveDisabled = false;

  return (
    <div className="flex flex--center">
      <button
        className={"relative ui-button2 bold ui-button5--wide ui-button2--green" + (saveDisabled ? " ui-button--disabled" : "")}
        disabled={saveDisabled}
        onClick={savePricingPageChanges}>
        <FormattedMessage id="messageBox.buttons.save"/>
        {pricingUpdatesCount ? (
          <span className="updateCount updateCount--small" title="Unsaved item count">{pricingUpdatesCount}</span>
        ) : null}
      </button>
    </div>
  )
};

const mapStateToProps = (store) => {
  return {
    pricingUpdatesCount: getCurrentUpdateCount(store),
  };
};

const mapDispatchToProps = {
  savePricingPageChanges
};

export default connect(mapStateToProps, mapDispatchToProps)(PricingTopPanelButtons);
